/*@ngInject*/
const ExternalAccountRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getExternalAccounts = function (userId) {
        let url = '/rest/UnderwritingUser/' + userId + '/externalAuthentications';
        return this.get(url);
    };

    this.save = function (userId, externalAuthentications) {
        let url = '/rest/UnderwritingUser/' + userId + '/saveExternalAuthentications';
        return this.post(url, externalAuthentications);
    };
};

angular.module('ums')
    .service('externalAccountRepository', ExternalAccountRepository);
